import { cloneDeep } from "lodash";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../../redux/slices/treeSlice";
import { getUpdatedData } from "./NewRecordOutbound"
import { RECORD_TYPE, DATA_TYPE } from "../../../constants/datatypes";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genKey } from "../../../utils/utilFunctions";
import { getUnnamedMapName } from "../../ItemProperties/Forms/OutboundFieldPropertyForm";

const NewFieldOutbound = ({ toggle, openModal }) => {
    const { t } = useTranslation();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const currentTab = rightTree.currentTab;
    const selectedNode = rightTree.tree[currentTab].selectedNode;
    const templateHeader = rightTree.tree.templateHeader;
    const [showModal, setShowModal] = useState(false);
    const content = t('BOX_LIKE_TO_PLACE_ITEM_INSIDE_CURR_REC_OR_DIRECTLY_AFTER').split(`\\n`).map((str, idx) => <div key={idx}>{str ? str : <br />}</div>);
    const dispatch = useDispatch();
    const contentRef = useRef();
    const handleNewField = (isInside) => {
        let nestedLevels = selectedNode.key.split("-");
        nestedLevels = nestedLevels.splice(1);
        const translatedData = cloneDeep(rightTree.tree[currentTab].translatedData);

        // Function For Getting New Field Title and Key
        const getNewFieldData = (data, key) => {
            //If it is empty so it will make first node with 'ob-0' key
            if (!data.length) return { key: `${key}-0`, title: `${t('UNNAMED')}`, insertingPosition: 1 };

            let latestNewNodeNum = 0;
            let insertingPosition = 1;
            let hasUnnamed0 = false;
            data.forEach((ele, idx) => {
                // Checking if Unnamed is present already for creating next unnamed record
                const fieldTitle = ele?.title;
                if (fieldTitle && fieldTitle.startsWith(`${t("LBL_FIELD")} ${t("UNNAMED")}`)) {
                    let unText = fieldTitle.replace(`${t("LBL_FIELD")} `, '');
                    const latestUnnamedRecord = Number(unText.slice(t("UNNAMED").length));
                    if ([`${t("UNNAMED")}`, "UNNAMED"].includes(unText)) hasUnnamed0 = true;
                    if (!isNaN(latestUnnamedRecord) && DATA_TYPE[templateHeader?.FILETYPE]?.field?.icon === ele?.ICON_DISPLAY) {
                        latestNewNodeNum =
                            latestUnnamedRecord > latestNewNodeNum
                                ? latestUnnamedRecord
                                : latestNewNodeNum;
                    }
                }
                if (ele.key === selectedNode.key) {
                    insertingPosition = idx + 2;
                }
            });

            const lastRecordKey = data[data.length - 1].key.split("-");
            lastRecordKey[lastRecordKey.length - 1] = +lastRecordKey[lastRecordKey.length - 1] + 1;
            const newRecordKey = lastRecordKey.join("-");
            let unnamedNumber = 0
            if (latestNewNodeNum > 0) {
                unnamedNumber = latestNewNodeNum + 1;
            } else {
                if (hasUnnamed0) unnamedNumber = 1;
                else unnamedNumber = '';
            }

            const name = getUnnamedMapName(data);
            return {
                key: newRecordKey,
                title: name,
                insertingPosition,
            };
        };

        // Inserting New Node Object in Tree Data (Recursive Function);
        function insertNodeInNestedTree(translatedData, nestedLevels, isInside) {
            const level = isInside ? 0 : 1;
            if (nestedLevels.length === level) {
                const { children, key } = translatedData;
                const newFieldDetails = children
                    ? getNewFieldData(children, key)
                    : getNewFieldData(translatedData, {header: "obh-0", body: "ob-0", trailer: "obt-0"}[currentTab]);
                let newName = newFieldDetails.title ? `${newFieldDetails.title}` : t("UNNAMED")
                const newNode = {
                    // nodeId:genKey(newFieldDetails.title),
                    // key: newFieldDetails.key,
                    // title: newFieldDetails.title ? `${t("LBL_FIELD")} ${newFieldDetails.title}` : t("UNNAMED"),
                    // NAME: newName,
                    // ICON_DISPLAY: "FIELD",
                    // children: [],
                    // fieldNumber: newFieldDetails.insertingPosition,
                    // MAPNAME: newName, //in 10.x, new fields dont have MAPNAME, but JSON from 11.x shows a MAPNAME same as DESCRIPTION.
                    // DESCRIPTION: newName, 
                    // FIELDTYPE: "ALPHA", 
                    // FILLCHAR: "+", 
                    // PADDIR: "RIGHT"

                    DESCRIPTION: newFieldDetails.title || t("UNNAMED"),
                    FIELDTYPE: "ALPHA",
                    FILLCHAR: " ",
                    ICON_DISPLAY: "FIELD",
                    PADDIR: "RIGHT",
                    children: [],
                    fieldNumber: templateHeader?.FILETYPE === "EDI" ? newFieldDetails.insertingPosition - 1 : newFieldDetails.insertingPosition,
                    key: newFieldDetails.key,
                    nodeId: genKey(newFieldDetails.title),
                    alternateNodeId: genKey(newFieldDetails.title),
                    title: newFieldDetails.title ? `${t("LBL_FIELD")} ${newFieldDetails.title}` : t("UNNAMED"),
                    ...(templateHeader?.FILETYPE === 'HL7' ? { DATA_TYPE: 'ST'} : {}),
                };
                if(templateHeader?.FILETYPE === 'DATABASE' && [true,'true','TRUE'].includes(templateHeader.INCLUDE_NULL) ) newNode.INCLUDE_NULL = 'TRUE'
                const formattingOptions = ['TRIMDATA', 'QUOTE_DATA', 'URLENCODE'];
                formattingOptions.forEach(condition => {
                    if ([true, 'true', 'TRUE'].includes(templateHeader[condition])) {
                        newNode[condition] = 'TRUE';
                    }
                });
                // Set escape data for JSON templates by default
                if (templateHeader?.FILETYPE === 'JSON') {
                    newNode.ESCAPE_DATA = 'TRUE';
                }
                dispatch(treeActions.setRightTreeSelectedNode({
                    screen: parentScreen,
                    type: currentTab,
                    data: {}
                }));
                if (children) {
                    if (isInside) {
                        translatedData.children.splice(0, 0, newNode);
                        let newKey = selectedNode.key.split('-');
                        newKey.push('0')
                        newKey = newKey.join('-');
                        setTimeout(()=>{
                            dispatch(treeActions.setRightTreeSelectedNode({
                                screen: parentScreen,
                                type: currentTab,
                                data: { ...newNode, key: newKey }
                            }));
                        })
                    } else {
                        const tempKey = selectedNode?.key?.split('-');
                        const lastIndex = + tempKey[tempKey.length-1] + 1

                        if(selectedNode?.ICON_DISPLAY === 'CONDITION_IF' && translatedData?.children[lastIndex]?.ICON_DISPLAY === "CONDITION_ELSE"){
                            translatedData.children.splice(lastIndex+1, 0, newNode);
                            let newKey = selectedNode.key.split('-');
                            newKey[newKey.length - 1] = Number(newKey[newKey.length - 1]) + 2;
                            newKey = newKey.join('-');
                            //  newNode.RECORD_TYPE = selectedNode?.RECORD_TYPE;
                            setTimeout(()=>{
                                dispatch(treeActions.setRightTreeSelectedNode({
                                    screen: parentScreen,
                                    type: currentTab,
                                    data: { ...newNode, key: newKey }
                                }));
                            })
                        }
                        else{
                        translatedData.children.splice(newFieldDetails.insertingPosition - 1, 0, newNode);
                        let newKey = selectedNode.key.split('-');
                        newKey[newKey.length - 1] = Number(newKey[newKey.length - 1]) + 1;
                        newKey = newKey.join('-');
                        //  newNode.RECORD_TYPE = selectedNode?.RECORD_TYPE;
                        setTimeout(()=>{
                            dispatch(treeActions.setRightTreeSelectedNode({
                                screen: parentScreen,
                                type: currentTab,
                                data: { ...newNode, key: newKey }
                            }));
                        })
                    }
                }
                }
                return;
            }

            const isArray = Array.isArray(translatedData);
            if (isArray) {
                const nestedData = translatedData[[nestedLevels[0]]];
                const newNestedLevels = nestedLevels.splice(1);
                insertNodeInNestedTree(nestedData, newNestedLevels, isInside);
            } else {
                // const newNestedLevels = nestedLevels.splice(1);
                insertNodeInNestedTree(translatedData.children, nestedLevels, isInside);
            }
        }

        insertNodeInNestedTree(translatedData, nestedLevels, isInside);
        const updatedData = getUpdatedData(translatedData, templateHeader?.FILETYPE, null, parentScreen === 'workflow', currentTab);
        console.log("updatedData", updatedData, currentTab);
        dispatch(
            treeActions.setRightTreeTransData({
                screen: parentScreen,
                type: currentTab,
                data: updatedData,
            })
        );
        toggle(null);
        setShowModal(false);
    };

    const newFieldOutboundHendlar = () => {
        if (selectedNode.key.split("-").length === 2) {
            handleNewField(true)
        }
        else if (selectedNode.ICON_DISPLAY === "QUERY" && selectedNode?.TYPE === 'QUERY') {
            handleNewField(false)
        }
        else if (["CONDITION_IF", "CONDITION_ELSE","FIELD_GROUP"].includes(selectedNode.ICON_DISPLAY) && openModal) {
            setShowModal(true);
        }
        else if (!RECORD_TYPE[selectedNode.ICON_DISPLAY] && openModal) {
            handleNewField(false);
        }
        else {
            setShowModal(true);
        }
    }
    useEffect(() => {
        if (openModal) {
            newFieldOutboundHendlar();
        }
    }, [openModal])

    return (
        <Dialog open={showModal} maxWidth="xs" fullWidth>
            <DialogTitle className="dialog-header">
                <div className="title">
                    {t("BOX_CONFIRM")}
                </div>
            </DialogTitle>
            <DialogContent className="dialog-content" dividers>
                <div>{content}</div>
            </DialogContent>
            <DialogActions>
                <Button size='small' variant="outlined" color="primary" onClick={() => handleNewField(true)} >
                    {t("BTN_YES")}
                </Button>
                <Button size='small' variant="outlined" color="primary" onClick={() => handleNewField(false)} >
                    {t("BTN_NO")}
                </Button>
                <Button size='small' variant="outlined" color="primary" onClick={() => {
                    toggle(null);
                    setShowModal(false);
                }} >
                    {t("BTN_CANCEL")}
                </Button>
            </DialogActions>
        </Dialog>
    )
};


export default NewFieldOutbound;